import { Component, ViewChild } from '@angular/core';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectCurrentAccount, selectCurrentOrganizationId, selectMyOrganizations } from '@input-output-labs/ngleaf';

interface SessionGate {
  ready: boolean;
  needsOrganization: boolean;
}

@Component({
  standalone: false,
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  readonly gate$: Observable<SessionGate>;
  @ViewChild(MatDrawerContainer) private drawerContainer?: MatDrawerContainer;
  private drawerSync = 0;

  constructor(store: Store) {
    this.gate$ = combineLatest([
      store.select(selectCurrentAccount),
      store.select(selectMyOrganizations),
      store.select(selectCurrentOrganizationId),
    ]).pipe(
      map(([account, organizations, organizationId]) => {
        const accountReady = account.status.success === true && !!account.data;
        const organizationsSettled = organizations.status.success === true || organizations.status.failure === true;
        return {
          ready: accountReady && !!organizationId,
          needsOrganization: accountReady && organizationsSettled && !organizationId,
        };
      })
    );
  }

  onMenuCollapsed(): void {
    const generation = ++this.drawerSync;
    const start = performance.now();
    const tick = () => {
      if (generation !== this.drawerSync) {
        return;
      }
      this.drawerContainer?.updateContentMargins();
      if (performance.now() - start < 240) {
        requestAnimationFrame(tick);
      }
    };
    tick();
  }
}
